import type { TFunction } from 'i18next'

import { shouldUseDKReportContent } from '../../../../../utils/isSupportedCountryId'
import { AmountField } from '../elements/exports/pdf/types/amountField'

type AmountPropertyKey = keyof AmountField

export interface AmountColumnConfig {
  labels: string[]
  amountKeys: AmountPropertyKey[]
}

export const getAmountColumnConfig = (
  countryId: string | undefined,
  fields: AmountField[],
  t: TFunction,
): AmountColumnConfig => {
  if (!fields.length || shouldUseDKReportContent(countryId)) {
    return { labels: [], amountKeys: [] }
  }

  const hasTurnover = fields.some((field) => field.turnoverAmount !== undefined)
  const hasVat = fields.some((field) => field.vatAmount !== undefined)

  if (countryId === 'FR') {
    const hasBoth = hasTurnover && hasVat
    if (hasBoth) {
      return {
        labels: [t('vat_declarations.report.subtitle.tax_free'), t('vat_declarations.report.subtitle.tax_due')],
        amountKeys: ['turnoverAmount', 'vatAmount'],
      }
    }
    if (hasTurnover) {
      return {
        labels: [t('vat_declarations.report.subtitle.tax_free')],
        amountKeys: ['turnoverAmount'],
      }
    }
    return {
      labels: [t('vat_declarations.report.subtitle.tax_due')],
      amountKeys: ['vatAmount'],
    }
  }

  const labels: string[] = []
  const amountKeys: AmountPropertyKey[] = []

  if (hasTurnover) {
    labels.push(t('vat_declaration.details_table.header.turnover'))
    amountKeys.push('turnoverAmount')
  }
  if (hasVat) {
    labels.push(t('vat_declaration.details_table.header.vat'))
    amountKeys.push('vatAmount')
  }

  return { labels, amountKeys }
}
